module.exports = __webpack_public_path__ + "img/logo.4d55b4e8.png";